import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionStoreRepository } from "../../shared/repositories/session.repository";
import { LoadingSpinnerGrowComponent } from "../../shared/components/loading/loading-spinner-grow/loading-spinner-grow.component";
import { TranslocoDirective } from "@jsverse/transloco";


@Component({
    selector: "web-patient-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
    imports: [LoadingSpinnerGrowComponent, TranslocoDirective]
})
export class LoginComponent implements OnInit {
    constructor(
        private readonly sessionService: SessionStoreRepository,
        private readonly router: Router,
        private readonly route: ActivatedRoute
    ) { }

    public ngOnInit() {
        const schemaAccessKey = this.route.snapshot.queryParamMap.get("schemaaccesskey");
        if (schemaAccessKey) {
            this.sessionService.storeSchemaAccessKey(schemaAccessKey);
        }

        setTimeout(() => {
            if (this.sessionService.isLoggedIn()) {
                this.router.navigate(["/auth"]);
            } else {
                this.sessionService.redirectToStsLoginPage();
            }
        }, 2000);
    }
}
